import { render, staticRenderFns } from "./FaceIcons.vue?vue&type=template&id=5f97c092&scoped=true"
import script from "./FaceIcons.vue?vue&type=script&lang=js"
export * from "./FaceIcons.vue?vue&type=script&lang=js"
import style0 from "./FaceIcons.vue?vue&type=style&index=0&id=5f97c092&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f97c092",
  null
  
)

export default component.exports